import { env } from '@noor/config';

/**
 * Attachment rules, verbatim from the old composer's guards: at most one
 * image per message, 10 MB, PNG/SVG/JPEG only (the picker's `accept`
 * attribute enforces the kind; size/duplicates/count are checked below).
 */
export const MERCHANT_CHAT_MAX_FILES = 1;
export const MERCHANT_CHAT_MAX_FILE_SIZE = 10 * 1024 * 1024;
export const MERCHANT_CHAT_ACCEPT = 'image/png, image/svg+xml, image/jpeg';

export type MerchantChatFileError =
  | 'chat.toast.max_file_size'
  | 'chat.toast.file_exist'
  | 'chat.toast.max_file_count';

/** The old `handleFileChange` guards as a pure function (toast key or null). */
export function validateMerchantChatFile(
  existing: File[],
  incoming: File,
): MerchantChatFileError | null {
  if (incoming.size > MERCHANT_CHAT_MAX_FILE_SIZE) return 'chat.toast.max_file_size';
  if (existing.some((file) => file.name === incoming.name))
    return 'chat.toast.file_exist';
  if (existing.length >= MERCHANT_CHAT_MAX_FILES) return 'chat.toast.max_file_count';
  return null;
}

/**
 * Resolve a stored attachment path to a fetchable URL — the same rule as
 * `legacyFileUrl`, restated here because entities must not import each other:
 * absolute URLs pass through, bare names are unusable, the rest hang off the
 * file host.
 */
export function merchantChatFileUrl(path: string | null | undefined): string | null {
  if (!path || path.split('/').length <= 1) return null;
  if (
    path.startsWith('https://') ||
    path.startsWith('http://') ||
    path.startsWith('blob:')
  ) {
    return path;
  }
  return `${env.VITE_FILE_API_URL}/${path}`;
}
